import apiRequest from './apiRequest';

export type MotionStatus =
  | 'QUEUED'
  | 'GENERATING'
  | 'COMPLETED'
  | 'FAILED'
  | 'CANCELLED';

export type FaceURLs = {
  bvhURL?: string;
  jsonURL?: string;
};

export type MotionRecord = {
  jobID: string;
  status: MotionStatus;
  bvhURL?: string;
  bvhURLs?: string[];
  /** Some gateways / serializers use snake_case; we normalize in batch stores. */
  bvh_urls?: string[];
  cwmsURL?: string;
  /** Presigned URL for the camera FBX file. Omitted when not present. */
  cameraFbxURL?: string;
  /** Presigned URL for the camera JSON file. Omitted when not present. */
  cameraJsonURL?: string;
  /** Per-person presigned face file URLs. One entry per person in the scene. Omitted when not present. */
  faceURLs?: FaceURLs[];
  /** Studio MHR BVH URLs per output index; aligned with `mhrIdentityJsonURLs` / `outputs[]`. Omitted when absent. */
  mhrBvhURLs?: string[];
  /** Studio MHR identity JSON URLs per output index. Omitted when absent. */
  mhrIdentityJsonURLs?: string[];
  /** Batch comic: UserMedia ID of the uploaded source clip (GET /media/{id} for presigned URL). */
  sourceVideoMediaID?: string;
  /**
   * Presigned URLs for the user-requested export format, one per ExportRequestRecord.
   * `null` when that export file is not ready yet.
   */
  exportURLs?: (string | null)[];
  export_urls?: (string | null)[];
  /** Download basenames aligned with `exportURLs` (`{filenamePrefix}.{ext}`). */
  exportFilenames?: (string | null)[];
  export_filenames?: (string | null)[];
  createdBy: string;
  createdAt: string;
  lastUpdatedAt: string;
  studioPreviewURL: string;
  title: string;
};

export type MotionsByGroupResponse = {
  items: MotionRecord[];
  nextToken?: string;
};

export default async function getMotionsByGroup(
  groupID: string,
  apiKey: string,
  nextToken?: string,
) {
  const params = nextToken ? `?nextToken=${encodeURIComponent(nextToken)}` : '';

  return await apiRequest<MotionsByGroupResponse>(
    'external-mogen',
    `/motions/${groupID}${params}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
